export function findComposeContact(contacts, email) {
    if (!email || !contacts?.length) return null;
    const e = String(email).toLowerCase().trim();
    return (
        contacts.find(
            (c) => c._type === 'contact' && c.email && String(c.email).toLowerCase().trim() === e
        ) || null
    );
}

export function normalizePhoneDigits(value) {
    return String(value || '').replace(/\D/g, '');
}
